<template>
    <div class="animated fadeIn master-form-page">
        <!-- Back Button -->
        <div class="mb-3">
            <button type="button" class="btn btn-back" @click="$router.go(-1)">
                <i class="fa fa-chevron-left mr-1"></i> Back
            </button>
        </div>

        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        
        <div v-else class="master-form-card">
            <h4 class="form-page-title">Input Merk Barang</h4>
            
            <b-form @submit.prevent="openModalConfirm">
                <!-- DATA UMUM -->
                <div class="form-section-block">
                    <div class="form-section-header no-border">
                        <span class="section-accent-bar"></span>
                        <span class="section-label">DATA UMUM</span>
                    </div>

                    <b-row>
                        <b-col md="4" class="form-field-group">
                            <label class="field-label" for="selectTipePinjaman">Tipe Pinjaman</label>
                            <b-form-select
                                id="selectTipePinjaman"
                                v-model="input.tipePinjaman"
                                name="tipePinjaman"
                                :options="tipePinjaman"
                                value-field="id"
                                text-field="name"
                                class="field-select w-100"
                                required
                            >
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Tipe Pinjaman</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="4" class="form-field-group">
                            <label class="field-label" for="selectJenisBarang">Jenis Barang</label>
                            <b-form-select
                                id="selectJenisBarang"
                                v-model="input.jenisBarang"
                                name="jenisBarang"
                                :options="jenisBarangOptions"
                                value-field="id"
                                text-field="name"
                                class="field-select w-100"
                                :disabled="input.tipePinjaman == null"
                                required
                            >
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>{{ input.tipePinjaman == null ? 'Pilih tipe pinjaman dulu' : 'Jenis Barang' }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="4" class="form-field-group">
                            <label class="field-label" for="inputMerkBarang">Nama Merk Barang</label>
                            <b-form-input 
                                id="inputMerkBarang"
                                v-model="input.merkBarang" 
                                name="merkBarang" 
                                placeholder="Nama Merk Barang"
                                class="field-input w-100"
                                required
                            ></b-form-input>
                        </b-col>
                    </b-row>
                </div>

                <!-- SPESIFIKASI -->
                <div class="form-section-block">
                    <div class="form-section-header">
                        <span class="section-accent-bar"></span>
                        <span class="section-label">SPESIFIKASI</span>
                    </div>

                    <button type="button" class="btn btn-add-section" @click="addSpesifikasi" name="spesifikasiAddBtn">
                        <i class="fa fa-plus mr-1"></i> Spesifikasi
                    </button>

                    <div v-if="input.spesifikasi.length === 0" class="empty-dashed-box">
                        Belum ada Spesifikasi ditambahkan.
                    </div>
                    <div v-else>
                        <Spesifikasi 
                            v-for="item in input.spesifikasi" 
                            :key="item.index"
                            :spesifikasi="item" 
                            :length="input.spesifikasi.length" 
                            @remove="removeSpesifikasi"
                        />
                    </div>
                </div>

                <!-- KONDISI -->
                <div class="form-section-block">
                    <div class="form-section-header">
                        <span class="section-accent-bar"></span>
                        <span class="section-label">KONDISI</span>
                    </div>

                    <button type="button" class="btn btn-add-section" @click="addKondisi" name="kondisiAddBtn">
                        <i class="fa fa-plus mr-1"></i> Kondisi
                    </button>

                    <div v-if="input.kondisi.length === 0" class="empty-dashed-box">
                        Belum ada Kondisi ditambahkan.
                    </div>
                    <div v-else>
                        <Kondisi 
                            v-for="item in input.kondisi" 
                            :key="item.index"
                            :kondisi="item" 
                            :length="input.kondisi.length" 
                            :isKendaraan="isKendaraan" 
                            @remove="removeKondisi"
                        />
                    </div>
                </div>

                <!-- Actions Footer -->
                <div class="form-actions-footer">
                    <button type="submit" name="merkBarangSubmitBtn" class="btn btn-submit" :disabled="isSubmitting">
                        Kirim
                    </button>
                    <button type="button" class="btn btn-cancel" @click="$router.go(-1)">
                        Batal
                    </button>
                </div>
            </b-form>
        </div>

        <ModalConfirm 
            id="modal-confirm-input" 
            title="Confirm Input Merk Barang" 
            :isSubmitting="isSubmitting" 
            desc="Apakah anda yakin untuk menginput merk barang ini?" 
            @submit="onSubmit" 
        />
    </div>
</template>

<script>
import Spesifikasi from '../../../components/spesifikasi/Spesifikasi';
import Kondisi from '../../../components/kondisi/Kondisi';
export default {
    name: 'input-merk-barang',
    components: { 
        Spesifikasi, Kondisi
    },
    data(){
        return{
            initStatus: 0,
            isSubmitting: false,
            input:{
                merkBarang: "",
                tipePinjaman: null,
                jenisBarang: null,
                spesifikasi: [],
                kondisi: [],
            },
            jenisBarang: [],
            tipePinjaman: [],
            indexSpesifikasi: 0,
            indexKondisi: 0,
            isKendaraan: false
        }
    },

    computed: {
        // Jenis barang hanya dari tipe pinjaman terpilih, supaya nama yang sama antar tipe tidak tampil dobel
        jenisBarangOptions() {
            if (this.input.tipePinjaman == null) return []
            return this.jenisBarang.filter(item => item.jenisPinjaman && item.jenisPinjaman.id == this.input.tipePinjaman)
        }
    },

    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0

            let getJenisBarang = this.$axios.get("barang-jenis/").then(response => {
                this.jenisBarang = response.data
            })

            let getTipePinjaman = this.$axios.get("jenis-pinjaman/").then(response => {
                this.tipePinjaman = response.data
            })

            Promise.all([getJenisBarang, getTipePinjaman]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
        

        //----------------- Fungsi Tambah Hapus Data Spesifikasi & Kondisi -----------------

        addSpesifikasi() {
            this.input.spesifikasi.unshift({ 
                index: this.indexSpesifikasi, 
                id: 0, 
                name: "", 
                detailInfo: "persen", 
                nominalPersen: null, 
                nominalAngka: null 
            })
            this.indexSpesifikasi++;
        },

        removeSpesifikasi(index) {
            this.input.spesifikasi = this.input.spesifikasi.filter(item => item.index != index)
        },

        addKondisi() {
            this.input.kondisi.unshift({ 
                index: this.indexKondisi, 
                id: 0, 
                name: "", 
                dus: 0,
                namaSendiri: 0,
                detailInfo: "persen",
                nominalPersen: null,
                nominalAngka: null,
                hargaMaksimal: 0
            })
            this.indexKondisi++;
        },

        removeKondisi(index) {
            this.input.kondisi = this.input.kondisi.filter(item => item.index != index)
        },


        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            var status = ""
            let payload = new FormData()

            //----------------- Append Data Merk Barang -----------------

            if (this.input.spesifikasi.length != 0) {
                for (var x of this.input.spesifikasi) {
                    payload.append("spesifikasiId", 0)
                    payload.append("spesifikasiName", x.name)
                    if (x.detailInfo == "nominal") {
                        let nominalAngka = this.$helper.removeThousandSeparator(x.nominalAngka);
                        payload.append('spesifikasiNominalAngka', nominalAngka)
                        payload.append('spesifikasiNominalPersen', null)
                    } 
                    else {
                        payload.append('spesifikasiNominalPersen', x.nominalPersen)
                        payload.append('spesifikasiNominalAngka', null)
                    }
                }
            }

            for (var x of this.input.kondisi) {
                payload.append('kondisiId', 0)
                payload.append('kondisiName', x.name)
                const nominalHargaMaks = this.$helper.removeThousandSeparator(x.hargaMaksimal);
                payload.append('kondisiHargaMaksimal', nominalHargaMaks)
                if(this.isKendaraan == false){
                    if (x.dus == 0) {
                        status = true
                    } 
                    else {
                        status = false
                    }
                    payload.append('kondisiDus', status)
                } 
                else {
                    if (x.namaSendiri== 0) {
                        status = true
                    } 
                    else {
                        status = false
                    }
                    payload.append('kondisiNamaSendiri', status)
                }
                if (x.detailInfo == "nominal") {
                    let nominalAngka = this.$helper.removeThousandSeparator(x.nominalAngka);
                    payload.append('kondisiNominalAngka', nominalAngka)
                    payload.append('kondisiNominalPersen', null)
                } 
                else {
                    payload.append('kondisiNominalPersen', x.nominalPersen)
                    payload.append('kondisiNominalAngka', null)
                }
            }

            payload.append("name", this.input.merkBarang)
            payload.append("jenisBarangId", this.input.jenisBarang)

            
            //----------------- Submit Semua Data -----------------
            this.isSubmitting = true
            
            this.$axios.post("barang-merk/", payload).then(response => {
                this.$helper.setFlash(`Merk barang baru telah berhasil dibuat!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/") + `/${response.data.id}`
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            if (this.input.kondisi.length == 0) {
                this.$helper.toastErr(this, "Tolong masukkan minimal 1 kondisi")
            } 
            else this.$bvModal.show("modal-confirm-input")
        }

    },

    watch:{

        //----------------- Pantau Tipe Pinjaman -----------------

        'input.tipePinjaman': function(){
            if (!this.jenisBarangOptions.some(item => item.id == this.input.jenisBarang)) {
                this.input.jenisBarang = null
            }
        },

        //----------------- Pantau Jenis Barang -----------------

        'input.jenisBarang': function(id){
            let jenis = this.jenisBarang.filter(item => item.id == id)
            if (jenis && jenis.length > 0 && jenis[0].jenisPinjaman) {
                let namaJenis = jenis[0].jenisPinjaman.name
                if (namaJenis == 'Kendaraan') {
                    this.isKendaraan = true
                } 
                else if (namaJenis == 'Elektronik') {
                    this.isKendaraan = false
                }
            }
        }

    },

    created(){
        this.init()
    }
}
</script>
